import { render, staticRenderFns } from "./CheckboxHeader.vue?vue&type=template&id=57128126&"
import script from "./CheckboxHeader.vue?vue&type=script&lang=js&"
export * from "./CheckboxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports